import { render, staticRenderFns } from "./RsaPazienteAllegatiPage.vue?vue&type=template&id=6912aeb2"
import script from "./RsaPazienteAllegatiPage.vue?vue&type=script&lang=js"
export * from "./RsaPazienteAllegatiPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports